module.exports = __webpack_public_path__ + "static/media/cq_modifica_dati_blu.0214bff6.svg";